var _circle, _circle2, _circle3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpskillField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 637,
    viewBox: "0 -59 637 637",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 204.185,
    stroke: "#151C2B",
    strokeWidth: 28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 304.5,
    stroke: "#151C2B",
    strokeWidth: 28
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 112.854,
    fill: "#212C42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.176 227.387C319.324 230.828 319.092 236.17 315.657 239.323C314.038 240.807 311.994 241.542 309.959 241.542C307.672 241.542 305.397 240.618 303.734 238.802L295.188 229.47V309.099C295.188 313.792 291.417 317.562 286.75 317.562C282.083 317.562 278.313 313.784 278.313 309.117V229.47L269.77 238.804C266.616 242.231 261.277 242.495 257.846 239.331C254.41 236.193 254.18 230.841 257.327 227.387L280.293 202.05C283.489 198.554 289.537 198.554 292.736 202.05L316.176 227.387Z",
    fill: "#719CF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M362.688 275.375H337.375C332.734 275.375 328.938 279.172 328.938 283.812V309.125C328.938 313.766 332.734 317.562 337.375 317.562H362.688C367.328 317.562 371.125 313.766 371.125 309.125V283.812C371.125 279.172 367.328 275.375 362.688 275.375ZM379.562 199.438H337.375C332.716 199.438 328.938 203.216 328.938 207.875V250.062C328.938 254.722 332.716 258.5 337.375 258.5H379.562C384.222 258.5 388 254.722 388 250.062V207.875C388 203.216 384.229 199.438 379.562 199.438Z",
    fill: "#719CF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpskillField);
export default __webpack_public_path__ + "static/media/upskill-field.33cbb68603deb2029eae7acf4bad1ad9.svg";
export { ForwardRef as ReactComponent };